export const getFilePath = (path) => {
	if (!path) return null;
	else if (path.startsWith('/upload'))
		return process.env.REACT_APP_PATH_FILE + path;
	return path;
};
